export class ApplyIdInfo {
    textId! : string;
    buttonName! : string;
}